// extracted by mini-css-extract-plugin
export default {"mainImageBlock":"Landing_mainImageBlock__DebPg","centeredInBlock":"Landing_centeredInBlock__1-xyF","infoBlock":"Landing_infoBlock__JmFES"};